(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rossetta-christmas-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rossetta-christmas-product')) {
    customElements.define('rossetta-christmas-product', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.optionButtons = [...this.querySelectorAll('[data-option-value]')];
        this.optionButtons.forEach((button) => button.addEventListener('click', () => this.selectOption(button)));
        const currentVariantId = this.querySelector('[data-variant-id]')?.value;
        const currentVariant = this.variants.find((variant) => String(variant.id) === currentVariantId) || this.variants.find((variant) => variant.available) || this.variants[0];
        if (currentVariant) this.selectVariantOptions(currentVariant);
        this.updateOptionAvailability();
        this.querySelectorAll('[data-media-src]').forEach((button) => button.addEventListener('click', () => this.selectMedia(button)));
        this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.stepMedia(-1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.stepMedia(1));
        this.querySelector('[data-sticky-add]')?.addEventListener('click', () => this.querySelector('[data-add-to-cart]')?.click());
        this.initSocialVideos();
        this.initSupportTabs();
        this.observeForm();
        this.loadRecommendations();
      }
      selectOption(button) {
        if (button.disabled) return;
        const group = button.closest('[data-option-index]');
        const optionIndex = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-value]').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed','false'); });
        button.classList.add('is-selected'); button.setAttribute('aria-pressed','true');
        const selected = [...this.querySelectorAll('[data-option-index]')].map((item) => item.querySelector('.is-selected')?.dataset.optionValue);
        const exactVariant = this.variants.find((item) => item.available && item.options.every((value, index) => value === selected[index]));
        const fallbackVariant = this.variants.find((item) => item.available && item.options.slice(0, optionIndex + 1).every((value, index) => value === selected[index]));
        const variant = exactVariant || fallbackVariant;
        if (!variant) return;
        this.selectVariantOptions(variant);
        this.updateOptionAvailability();
        this.updateVariant(variant);
      }
      selectVariantOptions(variant) {
        this.querySelectorAll('[data-option-index]').forEach((group, index) => {
          group.querySelectorAll('[data-option-value]').forEach((item) => {
            const selected = item.dataset.optionValue === variant.options[index];
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        });
      }
      updateOptionAvailability() {
        const groups = [...this.querySelectorAll('[data-option-index]')];
        const selected = groups.map((group) => group.querySelector('.is-selected')?.dataset.optionValue);
        groups.forEach((group, optionIndex) => {
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const available = this.variants.some((variant) => variant.available
              && variant.options[optionIndex] === button.dataset.optionValue
              && variant.options.slice(0, optionIndex).every((value, index) => value === selected[index]));
            button.disabled = !available;
            button.setAttribute('aria-disabled', available ? 'false' : 'true');
          });
        });
      }
      updateVariant(variant) {
        this.querySelector('[data-variant-id]').value = variant.id;
        const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency: window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
        this.querySelector('[data-price]').textContent = format(variant.price);
        this.querySelector('[data-sticky-price]').textContent = format(variant.price);
        const compare = this.querySelector('[data-compare]');
        compare.textContent = variant.compare_at_price ? format(variant.compare_at_price) : '';
        compare.classList.toggle('is-hidden', !(variant.compare_at_price > variant.price));
        const add = this.querySelector('[data-add-to-cart]');
        const sticky = this.querySelector('[data-sticky-add]');
        add.disabled = !variant.available; sticky.disabled = !variant.available;
        this.querySelector('[data-add-label]').textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (variant.featured_media) this.querySelector(`[data-media-id="${variant.featured_media.id}"]`)?.click();
        history.replaceState({}, '', `${this.dataset.productUrl || location.pathname}?variant=${variant.id}`);
      }
      selectMedia(button) {
        const image = this.querySelector('.rcp__main-image'); if (!image) return;
        image.src = button.dataset.mediaSrc; image.srcset = ''; image.alt = button.dataset.mediaAlt || '';
        this.querySelectorAll('[data-media-src]').forEach((item) => item.classList.toggle('is-active', item === button));
      }
      stepMedia(direction) {
        const items = [...this.querySelectorAll('[data-media-src]')]; if (!items.length) return;
        const active = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
        items[(active + direction + items.length) % items.length].click();
      }
      initSocialVideos() {
        this.querySelectorAll('[data-social-video]').forEach((button) => button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.socialVideo); if (!dialog) return;
          dialog.showModal(); dialog.querySelector('video')?.play();
        }));
        this.querySelectorAll('.rcp__social-dialog').forEach((dialog) => {
          dialog.querySelector('[data-social-video-close]')?.addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
          dialog.addEventListener('close', () => { const video = dialog.querySelector('video'); if (video) { video.pause(); video.currentTime = 0; } });
        });
      }
      initSupportTabs() {
        const tabs = [...this.querySelectorAll('[data-support-tab]')];
        const panels = [...this.querySelectorAll('[data-support-panel]')];
        tabs.forEach((tab) => tab.addEventListener('click', () => {
          if (tab.classList.contains('is-active')) return;
          tabs.forEach((item) => { const active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); });
          panels.forEach((panel) => {
            const active = panel.dataset.supportPanel === tab.dataset.supportTab;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        }));
        this.querySelectorAll('[data-support-faq]').forEach((button) => button.addEventListener('click', () => {
          const item = button.closest('.rcp__support-faq');
          const answer = document.getElementById(button.getAttribute('aria-controls'));
          const open = button.getAttribute('aria-expanded') === 'true';
          this.querySelectorAll('[data-support-faq][aria-expanded="true"]').forEach((other) => { if (other !== button) this.toggleSupportFaq(other, false); });
          if (item && answer) this.toggleSupportFaq(button, !open);
        }));
      }
      toggleSupportFaq(button, open) {
        const item = button.closest('.rcp__support-faq');
        const answer = document.getElementById(button.getAttribute('aria-controls'));
        if (!item || !answer) return;
        button.setAttribute('aria-expanded', String(open));
        item.classList.toggle('is-open', open);
        if (open) {
          answer.hidden = false;
          answer.style.height = '0px';
          requestAnimationFrame(() => { answer.style.height = `${answer.scrollHeight}px`; });
          answer.addEventListener('transitionend', () => { if (button.getAttribute('aria-expanded') === 'true') answer.style.height = 'auto'; }, {once:true});
        } else {
          answer.style.height = `${answer.scrollHeight}px`;
          answer.offsetHeight;
          requestAnimationFrame(() => { answer.style.height = '0px'; });
          answer.addEventListener('transitionend', () => { if (button.getAttribute('aria-expanded') === 'false') answer.hidden = true; }, {once:true});
        }
      }
      observeForm() {
        const form = this.querySelector('.rcp__form'); const sticky = this.querySelector('[data-sticky-bar]');
        if (!form || !sticky) return;
        new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), {threshold:.05}).observe(form);
      }
      async loadRecommendations() {
        const node = this.querySelector('[data-recommendations-url]'); if (!node || node.querySelector('.rcp__product-grid')) return;
        try { const html = await fetch(node.dataset.recommendationsUrl).then((response) => response.text()); const doc = new DOMParser().parseFromString(html, 'text/html'); const grid = doc.querySelector('.rcp__product-grid'); if (grid) node.append(grid); } catch (_) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
